import { HCConfig, HCConfigAssets, HCConfigFeatures, HCConfigRules } from './hc-config';

export const piaui: HCConfig = {
         appName: 'Piauí Saúde Digital',
         hcId: '',
         isPublic: true,
         uf: 'PI',
         config: {
           trackingId: 'G-V435Q9PLDX',
           domain: 'app.piauisaudedigital.com.br',
           domainKey: 'appPiauiDomainUrl',
           reactDomainKey: 'appPiauiDomainReactUrl',
           hcParam: 'piaui',
           clientDomainHeader: 'piaui',
           govBrClientId: 'cuidar-piaui',
           supportChatKey:
             'MjlkMzhlN2ItZDE1Mi00MTgzLWIxMDAtNDE1MTVlZDhhMjZmOmU4YmM0YjQwMjY4NTQ2ODFkZDM1ZDhmMDI3NWRjYTc4YTU2NTg3MjJjZXNwMDA3MG4yZ0FsQ0dzYzExS0lTOE9uejNtY3dvRmg1SzhvRDJqcWc=',
         },

         assets: {
           logo: './assets/hc/piaui/piaui-digial-logo.png',
           uploadExternalFilesLogo: './assets/hc/piaui/piaui-digial-logo.png',
           preloaderLogo: './assets/hc/piaui/piaui-digial-logo.png',
           favicon: '/assets/hc/piaui/piaui-digial-logo.png',
         },

         links: {
           site: 'https://app.piauisaudedigital.com.br',
           termsOfUse: 'https://files.sosportal.com.br/termos-de-uso-piaui.html',
           policyPrivacy: 'https://piauisaudedigital.com.br/politica-de-privacidade-piaui.html',
           playstore: 'https://play.google.com/store/apps/details?id=com.ptm.piaui',
           appstore: 'https://apps.apple.com/br/app/piau%C3%AD-sa%C3%BAde-digital/id6470301042',
         },

         dataDeletion: {
           name: 'Piauí Saúde Digital',
           slug: 'piaui',
           agreementTermsUrl: 'https://piauisaudedigital.com.br/termo-de-consentimento-exclusao-conta-piaui.html',
           background: '#ffffff',
           logo: {
             src: HCConfigAssets.dataDeletionLogo('piaui'),
             width: 270,
             height: 180,
           },
         },

         firstAccess: {
           name: 'Piauí Saúde Digital',
           city: 'Piauí',
           slug: 'piaui',
           emailDomain: '@piauisaudedigital.com.br',
           abbreviation: 'pi',
           background: 'linear-gradient(45deg, #2d8efb, #034ea2 35%, #023f82)',
           logo: {
             src: './assets/hc/piaui/piaui-digial-logo.png',
             width: 200,
             height: 150,
           },
         },

         mealPlan: {
           enableDocumentCreation: false,
           enableSendFiles: true,
           documentTypes: {
             showMealPlan: true,
             showTherapeuticPlan: false,
             showNursingPlan: false,
           },
         },

         routes: {
           firstAccess: '/first-access/piaui',
         },

         features: [
           HCConfigFeatures.FIRST_ACCESS_SEE_MORE_CONTENT,
           HCConfigFeatures.FIRST_ACCESS_REGISTER,
           HCConfigFeatures.PROCEDURES_APAC_SADT,
           HCConfigFeatures.REFERRAL_GUIDE,
           HCConfigFeatures.REQUEST_ATTENDANCE,
           HCConfigFeatures.HC_ADM_CAN_CHANGE_PATIENT_PASSWORD,
           HCConfigFeatures.PATIENT_INVITE_AND_EDIT_FORM_INCLUDE_CNS,
           HCConfigFeatures.ENABLE_FIRST_ACCESS,
           HCConfigFeatures.MANCHESTER_QUESTIONNAIRE,
           HCConfigFeatures.ENABLE_LOGIN_WITH_GOV,
           HCConfigFeatures.VIOLENCE_VICTIM_IDENTIFICATION,
           HCConfigFeatures.PATIENT_COMPLEMENTARY_DATA_FORM_INCLUDE_ATYPICAL_CHILDREN_GUARDIAN,
           HCConfigFeatures.E_SUS_PROFESSIONAL_CLINICAL_HISTORY,
           HCConfigFeatures.CAMERA_MIC_PREVIEW_BEFORE_CALL_JOIN,
         ],

         rules: [
           HCConfigRules.PATIENT_INVITE_AND_EDIT_FORM_REQUIRE_CPF_OR_EMAIL_OR_CNS,
           HCConfigRules.APPOINTMENT_MANAGEMENT,
           HCConfigRules.HC_HAS_CNES,
           HCConfigRules.BLOCK_REGISTRATION_WITH_OUT_OF_STATE_ZIPCODE,
           HCConfigRules.PHYSICIAN_SIGNATURE_STATUS_WIDGET,
           HCConfigRules.DOCTORS_LIST_SHOW_DIGITAL_SIGNATURE_STATUS,
         ],
       };
